const APP_BACKEND_URL = process.env.REACT_APP_APP_BACKEND_URL || 'http://localhost:3001';

export interface LiveRankingItem {
    rank: number;
    channelName: string;
    videoTitle: string | null;
    channelThumbnail: string | null;
    viewers: number;
    peakViewers: number;
    videoId: string | null;
    /** ISO 8601 from stream `actualStartTime` (omitted on older API responses). */
    startedAt?: string | null;
    /** 'premiere' for YouTube premieres; 'live' otherwise (omitted on older API responses). */
    streamType?: 'live' | 'premiere';
}

export interface LiveRankingsResponse {
    rankings: LiveRankingItem[];
    updatedAt: string;
    totalCount: number;
    totalViewers: number;
}

export type LiveRankingsCategory = 'tv' | 'radio' | 'digital';

export const getLiveRankings = async (
    category?: LiveRankingsCategory
): Promise<LiveRankingsResponse> => {
    const qs = category !== undefined ? `?category=${encodeURIComponent(category)}` : '';
    const response = await fetch(`${APP_BACKEND_URL}/api/live/rankings${qs}`, {
        credentials: 'include',
    });

    if (response.status === 401) {
        throw new Error('LIVE_RANKINGS_UNAUTHORIZED');
    }
    if (!response.ok) {
        throw new Error('Failed to fetch live rankings');
    }

    return response.json();
};
